import { createI18n } from 'vue-i18n'
import enUS from './locales/en-US.json' // 英文
import jaJP from './locales/ja-JP.json' // 日文
import koKR from './locales/ko-KR.json' // 韩文

const messages = {
  'en': enUS,
  'ko': koKR,
  'kr': koKR,
  'jr': jaJP,
  'ja': jaJP,
  'jp': jaJP
}

const i18n = createI18n({
  legacy: false, // 必须设置为false，才能使用Composition API
  locale: import.meta.env.VITE_PAGE_LANGUAGE, // 默认语言
  fallbackLocale: import.meta.env.VITE_PAGE_LANGUAGE, // 备用语言
  globalInjection: true, // 全局注入$t方法
  messages
})

export default i18n